<template>
  <page>
    <template slot="content">
    <help-content :title="'WeBandの歩数がヘルスケアや他社製品と異なる原因'">
      <template slot="content">
        <div class="text">
          計測方法はデバイスのメーカーによって異なります。WeBandの歩数計測方法に、ユーザーの登録情報（身長や体重）を考慮し、独自のアルゴリズムで実際に歩いた歩数とできるだけ一致するように実現しています。<br><br>
          なお、ノイズデータ除去のために、<b>一定時間内において連続して歩いた歩数のみ</b>正しい歩数としてカウントされます。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help22.vue